<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1 style="padding-bottom:40px;">Acknowledgement</h1>
<p style="text-align: center;">I wish to thank all my ‘teachers’—past, present (and future), far too many<br/>
to name.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?e966ba2c